import {BrowserRouter, Routes, Route} from 'react-router-dom';
import './App.css';
import 'react-phone-number-input/style.css'
import './assets/scss/index.scss';

import CreateAccountController from './pages/authentication/registration';
import LoginController from './pages/authentication/login';
import ForgotPasswordController from './pages/authentication/forgotPassword';
import ChangePasswordController from './pages/authentication/changePassword';
import ResetPasswordController from './pages/authentication/resetPassword';
import VehicleController from './pages/vehicle';
import AddVehicleInfomationController from './pages/vehicle/addVehicleInformation';
import EditVehicleInfomationController from './pages/vehicle/editVehicleInfomation'
import ProfileController from './pages/profile';
import PaymentsController from './pages/payments';
import PaymentDetailsController from './pages/paymentsDetails';
import AddNewCardController from './pages/payments';
import {ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import ScrollToTop from "./components/scrollToTop";
import ProtectedRoute from "./components/protectedRoute";
import {useEffect} from "react";
import Logout from "./pages/authentication/logout";
function App() {
  const hasToken = () => {
    const token = sessionStorage.getItem('token')
    return token ? true : false
  }
  useEffect(() => {
    // Add reCaptcha
    const script = document.createElement("script")
    script.src = `https://www.google.com/recaptcha/api.js?render=${process.env.REACT_APP_RECAPTCHA_SITE_KEY}`
    document.body.appendChild(script)
  }, [])
  return (
    <div className="App">
      <BrowserRouter>
        <ToastContainer
            autoClose={10000}
        />
        <ScrollToTop/>
        <Routes>
          <Route path="/">
            <Route index={true} path="/" element={<LoginController />}/>
            <Route path="/login" element={<LoginController />}/>
            <Route path="/create-account" element={<CreateAccountController />}/>
            <Route path="/forgot-password" element={<ForgotPasswordController />}/>
            <Route path="/change-password/" element={<ChangePasswordController />}/>
            <Route path="/reset-password/:token" element={<ResetPasswordController />}/>
            <Route path="/logout" element={<Logout />}/>
            <Route path="/payment-details" element={<PaymentDetailsController />}/>
            <Route element={<ProtectedRoute isLoggedIn={hasToken}/>}>
              <Route path="/vehicle" element={<VehicleController />}/>
              <Route path="vehicle/add-vehicle-information" element={<AddVehicleInfomationController />}/>
              <Route path="vehicle/edit-vehicle-information/:vehicleId" element={<EditVehicleInfomationController />}/>
              <Route path="/payments" element={<PaymentsController />}/>
              <Route path="/payments/add-new-card" element={<AddNewCardController />}/>
              <Route path="/profile" element={<ProfileController />}/>
            </Route>
          </Route>
        </Routes> 
      </BrowserRouter>
    </div>
  );
}

export default App;
